import { makeActionCreator } from '../../../utilities'
import { AuthorizationInformationConstants } from './authorizationInformation.constants'

export const setTransportAuthorizationCode = makeActionCreator(
  AuthorizationInformationConstants.SET_TRANSPORTAUTHORIZATIONCODE,
  'transportAuthorizationCode'
)
export const setReasonForInterfacilityTransfer = makeActionCreator(
  AuthorizationInformationConstants.SET_REASONFORINTERFACILITYTRANSFER,
  'reasonForInterfacilityTransfer'
)
export const setReasonForInterfacilityTransferPNNV = makeActionCreator(
  AuthorizationInformationConstants.SET_REASONFORINTERFACILITYTRANSFER_PNNV,
  'reasonForInterfacilityTransferPNNV'
)
export const setJustificationForTransfer = makeActionCreator(
  AuthorizationInformationConstants.SET_JUSTIFICATIONFORTRANSFER,
  'justificationForTransfer'
)
export const saveAuthorizationInfo = makeActionCreator(AuthorizationInformationConstants.SAVE_AUTHORIZATIONINFO)
export const resetAuthorizationInformationState = makeActionCreator(AuthorizationInformationConstants.RESET_STATE)

export const setAuthorizationInformationState = makeActionCreator(
  AuthorizationInformationConstants.SET_AUTHORIZATION_INFORMATION_STATE,
  'authorizationInformationState'
)
